import type { Vector2 } from '../core/types';

// Vector font - each character is defined as a series of line segments
// Coordinates are on a 5x7 grid (width x height)

type Glyph = Vector2[][]; // Array of line segments, each segment is [start, end]

const GLYPHS: Record<string, Glyph> = {
  A: [
    [{ x: 0, y: 7 }, { x: 0, y: 2 }],
    [{ x: 0, y: 2 }, { x: 2.5, y: 0 }],
    [{ x: 2.5, y: 0 }, { x: 5, y: 2 }],
    [{ x: 5, y: 2 }, { x: 5, y: 7 }],
    [{ x: 0, y: 4 }, { x: 5, y: 4 }],
  ],
  B: [
    [{ x: 0, y: 0 }, { x: 0, y: 7 }],
    [{ x: 0, y: 0 }, { x: 4, y: 0 }],
    [{ x: 4, y: 0 }, { x: 5, y: 1 }],
    [{ x: 5, y: 1 }, { x: 5, y: 2.5 }],
    [{ x: 5, y: 2.5 }, { x: 4, y: 3.5 }],
    [{ x: 4, y: 3.5 }, { x: 0, y: 3.5 }],
    [{ x: 4, y: 3.5 }, { x: 5, y: 4.5 }],
    [{ x: 5, y: 4.5 }, { x: 5, y: 6 }],
    [{ x: 5, y: 6 }, { x: 4, y: 7 }],
    [{ x: 4, y: 7 }, { x: 0, y: 7 }],
  ],
  C: [
    [{ x: 5, y: 1 }, { x: 4, y: 0 }],
    [{ x: 4, y: 0 }, { x: 1, y: 0 }],
    [{ x: 1, y: 0 }, { x: 0, y: 1 }],
    [{ x: 0, y: 1 }, { x: 0, y: 6 }],
    [{ x: 0, y: 6 }, { x: 1, y: 7 }],
    [{ x: 1, y: 7 }, { x: 4, y: 7 }],
    [{ x: 4, y: 7 }, { x: 5, y: 6 }],
  ],
  D: [
    [{ x: 0, y: 0 }, { x: 0, y: 7 }],
    [{ x: 0, y: 0 }, { x: 3, y: 0 }],
    [{ x: 3, y: 0 }, { x: 5, y: 2 }],
    [{ x: 5, y: 2 }, { x: 5, y: 5 }],
    [{ x: 5, y: 5 }, { x: 3, y: 7 }],
    [{ x: 3, y: 7 }, { x: 0, y: 7 }],
  ],
  E: [
    [{ x: 5, y: 0 }, { x: 0, y: 0 }],
    [{ x: 0, y: 0 }, { x: 0, y: 7 }],
    [{ x: 0, y: 7 }, { x: 5, y: 7 }],
    [{ x: 0, y: 3.5 }, { x: 4, y: 3.5 }],
  ],
  F: [
    [{ x: 5, y: 0 }, { x: 0, y: 0 }],
    [{ x: 0, y: 0 }, { x: 0, y: 7 }],
    [{ x: 0, y: 3.5 }, { x: 4, y: 3.5 }],
  ],
  G: [
    [{ x: 5, y: 1 }, { x: 4, y: 0 }],
    [{ x: 4, y: 0 }, { x: 1, y: 0 }],
    [{ x: 1, y: 0 }, { x: 0, y: 1 }],
    [{ x: 0, y: 1 }, { x: 0, y: 6 }],
    [{ x: 0, y: 6 }, { x: 1, y: 7 }],
    [{ x: 1, y: 7 }, { x: 4, y: 7 }],
    [{ x: 4, y: 7 }, { x: 5, y: 6 }],
    [{ x: 5, y: 6 }, { x: 5, y: 4 }],
    [{ x: 5, y: 4 }, { x: 3, y: 4 }],
  ],
  H: [
    [{ x: 0, y: 0 }, { x: 0, y: 7 }],
    [{ x: 5, y: 0 }, { x: 5, y: 7 }],
    [{ x: 0, y: 3.5 }, { x: 5, y: 3.5 }],
  ],
  I: [
    [{ x: 1, y: 0 }, { x: 4, y: 0 }],
    [{ x: 2.5, y: 0 }, { x: 2.5, y: 7 }],
    [{ x: 1, y: 7 }, { x: 4, y: 7 }],
  ],
  J: [
    [{ x: 1, y: 0 }, { x: 5, y: 0 }],
    [{ x: 3.5, y: 0 }, { x: 3.5, y: 6 }],
    [{ x: 3.5, y: 6 }, { x: 2.5, y: 7 }],
    [{ x: 2.5, y: 7 }, { x: 1, y: 7 }],
    [{ x: 1, y: 7 }, { x: 0, y: 6 }],
  ],
  K: [
    [{ x: 0, y: 0 }, { x: 0, y: 7 }],
    [{ x: 5, y: 0 }, { x: 0, y: 3.5 }],
    [{ x: 0, y: 3.5 }, { x: 5, y: 7 }],
  ],
  L: [
    [{ x: 0, y: 0 }, { x: 0, y: 7 }],
    [{ x: 0, y: 7 }, { x: 5, y: 7 }],
  ],
  M: [
    [{ x: 0, y: 7 }, { x: 0, y: 0 }],
    [{ x: 0, y: 0 }, { x: 2.5, y: 4 }],
    [{ x: 2.5, y: 4 }, { x: 5, y: 0 }],
    [{ x: 5, y: 0 }, { x: 5, y: 7 }],
  ],
  N: [
    [{ x: 0, y: 7 }, { x: 0, y: 0 }],
    [{ x: 0, y: 0 }, { x: 5, y: 7 }],
    [{ x: 5, y: 7 }, { x: 5, y: 0 }],
  ],
  O: [
    [{ x: 1, y: 0 }, { x: 4, y: 0 }],
    [{ x: 4, y: 0 }, { x: 5, y: 1 }],
    [{ x: 5, y: 1 }, { x: 5, y: 6 }],
    [{ x: 5, y: 6 }, { x: 4, y: 7 }],
    [{ x: 4, y: 7 }, { x: 1, y: 7 }],
    [{ x: 1, y: 7 }, { x: 0, y: 6 }],
    [{ x: 0, y: 6 }, { x: 0, y: 1 }],
    [{ x: 0, y: 1 }, { x: 1, y: 0 }],
  ],
  P: [
    [{ x: 0, y: 7 }, { x: 0, y: 0 }],
    [{ x: 0, y: 0 }, { x: 4, y: 0 }],
    [{ x: 4, y: 0 }, { x: 5, y: 1 }],
    [{ x: 5, y: 1 }, { x: 5, y: 3 }],
    [{ x: 5, y: 3 }, { x: 4, y: 4 }],
    [{ x: 4, y: 4 }, { x: 0, y: 4 }],
  ],
  Q: [
    [{ x: 1, y: 0 }, { x: 4, y: 0 }],
    [{ x: 4, y: 0 }, { x: 5, y: 1 }],
    [{ x: 5, y: 1 }, { x: 5, y: 5 }],
    [{ x: 5, y: 5 }, { x: 4, y: 6 }],
    [{ x: 4, y: 6 }, { x: 5, y: 7 }],
    [{ x: 4, y: 6 }, { x: 1, y: 6 }],
    [{ x: 1, y: 6 }, { x: 0, y: 5 }],
    [{ x: 0, y: 5 }, { x: 0, y: 1 }],
    [{ x: 0, y: 1 }, { x: 1, y: 0 }],
    [{ x: 3, y: 5 }, { x: 5, y: 7 }],
  ],
  R: [
    [{ x: 0, y: 7 }, { x: 0, y: 0 }],
    [{ x: 0, y: 0 }, { x: 4, y: 0 }],
    [{ x: 4, y: 0 }, { x: 5, y: 1 }],
    [{ x: 5, y: 1 }, { x: 5, y: 3 }],
    [{ x: 5, y: 3 }, { x: 4, y: 4 }],
    [{ x: 4, y: 4 }, { x: 0, y: 4 }],
    [{ x: 2, y: 4 }, { x: 5, y: 7 }],
  ],
  S: [
    [{ x: 5, y: 1 }, { x: 4, y: 0 }],
    [{ x: 4, y: 0 }, { x: 1, y: 0 }],
    [{ x: 1, y: 0 }, { x: 0, y: 1 }],
    [{ x: 0, y: 1 }, { x: 0, y: 2.5 }],
    [{ x: 0, y: 2.5 }, { x: 1, y: 3.5 }],
    [{ x: 1, y: 3.5 }, { x: 4, y: 3.5 }],
    [{ x: 4, y: 3.5 }, { x: 5, y: 4.5 }],
    [{ x: 5, y: 4.5 }, { x: 5, y: 6 }],
    [{ x: 5, y: 6 }, { x: 4, y: 7 }],
    [{ x: 4, y: 7 }, { x: 1, y: 7 }],
    [{ x: 1, y: 7 }, { x: 0, y: 6 }],
  ],
  T: [
    [{ x: 0, y: 0 }, { x: 5, y: 0 }],
    [{ x: 2.5, y: 0 }, { x: 2.5, y: 7 }],
  ],
  U: [
    [{ x: 0, y: 0 }, { x: 0, y: 6 }],
    [{ x: 0, y: 6 }, { x: 1, y: 7 }],
    [{ x: 1, y: 7 }, { x: 4, y: 7 }],
    [{ x: 4, y: 7 }, { x: 5, y: 6 }],
    [{ x: 5, y: 6 }, { x: 5, y: 0 }],
  ],
  V: [
    [{ x: 0, y: 0 }, { x: 2.5, y: 7 }],
    [{ x: 2.5, y: 7 }, { x: 5, y: 0 }],
  ],
  W: [
    [{ x: 0, y: 0 }, { x: 1, y: 7 }],
    [{ x: 1, y: 7 }, { x: 2.5, y: 4 }],
    [{ x: 2.5, y: 4 }, { x: 4, y: 7 }],
    [{ x: 4, y: 7 }, { x: 5, y: 0 }],
  ],
  X: [
    [{ x: 0, y: 0 }, { x: 5, y: 7 }],
    [{ x: 5, y: 0 }, { x: 0, y: 7 }],
  ],
  Y: [
    [{ x: 0, y: 0 }, { x: 2.5, y: 3.5 }],
    [{ x: 5, y: 0 }, { x: 2.5, y: 3.5 }],
    [{ x: 2.5, y: 3.5 }, { x: 2.5, y: 7 }],
  ],
  Z: [
    [{ x: 0, y: 0 }, { x: 5, y: 0 }],
    [{ x: 5, y: 0 }, { x: 0, y: 7 }],
    [{ x: 0, y: 7 }, { x: 5, y: 7 }],
  ],
  '0': [
    [{ x: 1, y: 0 }, { x: 4, y: 0 }],
    [{ x: 4, y: 0 }, { x: 5, y: 1 }],
    [{ x: 5, y: 1 }, { x: 5, y: 6 }],
    [{ x: 5, y: 6 }, { x: 4, y: 7 }],
    [{ x: 4, y: 7 }, { x: 1, y: 7 }],
    [{ x: 1, y: 7 }, { x: 0, y: 6 }],
    [{ x: 0, y: 6 }, { x: 0, y: 1 }],
    [{ x: 0, y: 1 }, { x: 1, y: 0 }],
    [{ x: 0, y: 6 }, { x: 5, y: 1 }],
  ],
  '1': [
    [{ x: 1, y: 1 }, { x: 2.5, y: 0 }],
    [{ x: 2.5, y: 0 }, { x: 2.5, y: 7 }],
    [{ x: 1, y: 7 }, { x: 4, y: 7 }],
  ],
  '2': [
    [{ x: 0, y: 1 }, { x: 1, y: 0 }],
    [{ x: 1, y: 0 }, { x: 4, y: 0 }],
    [{ x: 4, y: 0 }, { x: 5, y: 1 }],
    [{ x: 5, y: 1 }, { x: 5, y: 2.5 }],
    [{ x: 5, y: 2.5 }, { x: 0, y: 7 }],
    [{ x: 0, y: 7 }, { x: 5, y: 7 }],
  ],
  '3': [
    [{ x: 0, y: 1 }, { x: 1, y: 0 }],
    [{ x: 1, y: 0 }, { x: 4, y: 0 }],
    [{ x: 4, y: 0 }, { x: 5, y: 1 }],
    [{ x: 5, y: 1 }, { x: 5, y: 2.5 }],
    [{ x: 5, y: 2.5 }, { x: 4, y: 3.5 }],
    [{ x: 4, y: 3.5 }, { x: 2, y: 3.5 }],
    [{ x: 4, y: 3.5 }, { x: 5, y: 4.5 }],
    [{ x: 5, y: 4.5 }, { x: 5, y: 6 }],
    [{ x: 5, y: 6 }, { x: 4, y: 7 }],
    [{ x: 4, y: 7 }, { x: 1, y: 7 }],
    [{ x: 1, y: 7 }, { x: 0, y: 6 }],
  ],
  '4': [
    [{ x: 4, y: 7 }, { x: 4, y: 0 }],
    [{ x: 4, y: 0 }, { x: 0, y: 5 }],
    [{ x: 0, y: 5 }, { x: 5, y: 5 }],
  ],
  '5': [
    [{ x: 5, y: 0 }, { x: 0, y: 0 }],
    [{ x: 0, y: 0 }, { x: 0, y: 3 }],
    [{ x: 0, y: 3 }, { x: 4, y: 3 }],
    [{ x: 4, y: 3 }, { x: 5, y: 4 }],
    [{ x: 5, y: 4 }, { x: 5, y: 6 }],
    [{ x: 5, y: 6 }, { x: 4, y: 7 }],
    [{ x: 4, y: 7 }, { x: 1, y: 7 }],
    [{ x: 1, y: 7 }, { x: 0, y: 6 }],
  ],
  '6': [
    [{ x: 4, y: 0 }, { x: 1, y: 0 }],
    [{ x: 1, y: 0 }, { x: 0, y: 1 }],
    [{ x: 0, y: 1 }, { x: 0, y: 6 }],
    [{ x: 0, y: 6 }, { x: 1, y: 7 }],
    [{ x: 1, y: 7 }, { x: 4, y: 7 }],
    [{ x: 4, y: 7 }, { x: 5, y: 6 }],
    [{ x: 5, y: 6 }, { x: 5, y: 4.5 }],
    [{ x: 5, y: 4.5 }, { x: 4, y: 3.5 }],
    [{ x: 4, y: 3.5 }, { x: 0, y: 3.5 }],
  ],
  '7': [
    [{ x: 0, y: 0 }, { x: 5, y: 0 }],
    [{ x: 5, y: 0 }, { x: 2, y: 7 }],
  ],
  '8': [
    [{ x: 1, y: 0 }, { x: 4, y: 0 }],
    [{ x: 4, y: 0 }, { x: 5, y: 1 }],
    [{ x: 5, y: 1 }, { x: 5, y: 2.5 }],
    [{ x: 5, y: 2.5 }, { x: 4, y: 3.5 }],
    [{ x: 4, y: 3.5 }, { x: 1, y: 3.5 }],
    [{ x: 1, y: 3.5 }, { x: 0, y: 2.5 }],
    [{ x: 0, y: 2.5 }, { x: 0, y: 1 }],
    [{ x: 0, y: 1 }, { x: 1, y: 0 }],
    [{ x: 4, y: 3.5 }, { x: 5, y: 4.5 }],
    [{ x: 5, y: 4.5 }, { x: 5, y: 6 }],
    [{ x: 5, y: 6 }, { x: 4, y: 7 }],
    [{ x: 4, y: 7 }, { x: 1, y: 7 }],
    [{ x: 1, y: 7 }, { x: 0, y: 6 }],
    [{ x: 0, y: 6 }, { x: 0, y: 4.5 }],
    [{ x: 0, y: 4.5 }, { x: 1, y: 3.5 }],
  ],
  '9': [
    [{ x: 1, y: 7 }, { x: 4, y: 7 }],
    [{ x: 4, y: 7 }, { x: 5, y: 6 }],
    [{ x: 5, y: 6 }, { x: 5, y: 1 }],
    [{ x: 5, y: 1 }, { x: 4, y: 0 }],
    [{ x: 4, y: 0 }, { x: 1, y: 0 }],
    [{ x: 1, y: 0 }, { x: 0, y: 1 }],
    [{ x: 0, y: 1 }, { x: 0, y: 2.5 }],
    [{ x: 0, y: 2.5 }, { x: 1, y: 3.5 }],
    [{ x: 1, y: 3.5 }, { x: 5, y: 3.5 }],
  ],
  ':': [
    [{ x: 2.5, y: 2 }, { x: 2.5, y: 2.5 }],
    [{ x: 2.5, y: 5 }, { x: 2.5, y: 5.5 }],
  ],
  ' ': [],
};

const CHAR_WIDTH = 5;
const CHAR_HEIGHT = 7;
const CHAR_SPACING = 1.5;

export interface TextSegment {
  start: Vector2;
  end: Vector2;
}

export function getTextSegments(
  text: string,
  x: number,
  y: number,
  scale: number
): TextSegment[] {
  const segments: TextSegment[] = [];
  const upperText = text.toUpperCase();

  let cursorX = x;

  for (const char of upperText) {
    const glyph = GLYPHS[char];
    if (glyph) {
      for (const line of glyph) {
        segments.push({
          start: {
            x: cursorX + line[0].x * scale,
            y: y + line[0].y * scale,
          },
          end: {
            x: cursorX + line[1].x * scale,
            y: y + line[1].y * scale,
          },
        });
      }
    }
    cursorX += (CHAR_WIDTH + CHAR_SPACING) * scale;
  }

  return segments;
}

export function getTextWidth(text: string, scale: number): number {
  return text.length * (CHAR_WIDTH + CHAR_SPACING) * scale - CHAR_SPACING * scale;
}

export function getTextHeight(scale: number): number {
  return CHAR_HEIGHT * scale;
}
